import { Button, Grid, Stack } from '@mui/material';
import { SimpleForm } from 'components/forms/SimpleForm';
import { CheckboxInput } from 'components/inputs/CheckboxInput';
import { SelectInput } from 'components/inputs/SelectInput';
import { TextInput } from 'components/inputs/TextInput';
import Panel from 'components/panels/Panel';
import { DEVICE_TYPE_IDS } from 'utils/constants';
import * as yup from 'yup';
import { TIMESERIES_DEVICE_TYPE_OPTIONS, TimeseriesFormValues } from './TestDataGenerator';

type TimeseriesFormProps = {
  defaultValues: TimeseriesFormValues;
  validationSchema: yup.ObjectSchema<TimeseriesFormValues>;
  generateBatchTimeseries: (data: TimeseriesFormValues) => void;
  generateLiveTimeseries: (data: TimeseriesFormValues) => void;
};

export const TimeseriesForm = ({
  defaultValues,
  validationSchema,
  generateBatchTimeseries,
  generateLiveTimeseries,
}: TimeseriesFormProps) => {
  return (
    <SimpleForm
      defaultValues={defaultValues}
      validationSchema={validationSchema}
      showButtons={false}
      onSubmit={() => {}}
    >
      {({ control, handleSubmit, formState, watch }) => {
        const deviceType = watch('deviceType');
        const isBattery = deviceType === DEVICE_TYPE_IDS.BATTERY;

        return (
          <Grid container spacing={3} sx={{ pr: 3, mt: 2 }}>
            <Grid item xs={12}>
              <Panel title="Timeseries configuration">
                <Grid container item spacing={3}>
                  <Grid item xs={12}>
                    <TextInput
                      control={control}
                      name="unitId"
                      label="Asset external identifier *"
                      gridSize={12}
                      placeholder="ex. GREENER_001"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <SelectInput
                      control={control}
                      name="deviceType"
                      label="Device type *"
                      gridSize={12}
                      options={TIMESERIES_DEVICE_TYPE_OPTIONS.map((o) => o.value)}
                      getOptionLabel={(option) =>
                        TIMESERIES_DEVICE_TYPE_OPTIONS.find((o) => o.value === option)?.label ?? ''
                      }
                      addNoneOption={false}
                    />
                  </Grid>
                  {isBattery && (
                    <Grid item xs={12}>
                      <CheckboxInput
                        control={control}
                        name="hasSecondInverter"
                        label="Device has a second inverter"
                        gridSize={12}
                      />
                    </Grid>
                  )}
                </Grid>
              </Panel>
            </Grid>
            <Grid container item xs={12} md={4}>
              <Panel title="Batch timeseries">
                <Stack direction="column" gap={2}>
                  <TextInput control={control} name="from" label="From *" gridSize={12} />
                  <TextInput control={control} name="to" label="To *" gridSize={12} />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleSubmit(generateBatchTimeseries)}
                    disabled={!formState.isValid}
                  >
                    Generate batch timeseries data
                  </Button>
                </Stack>
              </Panel>
            </Grid>
            <Grid item xs={12} md={4}>
              <Panel title="Live timeseries">
                <Stack direction="column" gap={2}>
                  <TextInput control={control} name="duration" label="Duration *" gridSize={12} />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleSubmit(generateLiveTimeseries)}
                    disabled={!formState.isValid}
                  >
                    Generate live timeseries data
                  </Button>
                </Stack>
              </Panel>
            </Grid>
          </Grid>
        );
      }}
    </SimpleForm>
  );
};
